import { Chip } from '@mui/material'
import {
  Black,
  GridTemplateLabelColor,
  IndicatedIssueLabelColor,
} from 'src/features/theme/KdsThemeColor'
import styled from 'styled-components'

export const ImproveOptionTag = styled(Chip)`
  && {
    color: ${Black};
    background-color: ${IndicatedIssueLabelColor};
    font-size: 12px;
    height: 18px;
    width: 56px;
    margin-left: 8px;
    border-radius: 4px;
    span {
      padding: 3px 4px;
    }
  }
`

export const GridTemplateTag = styled(Chip)`
  && {
    color: ${Black};
    background-color: ${GridTemplateLabelColor};
    font-size: 12px;
    height: 18px;
    width: 44px;
    margin-left: 8px;
    border-radius: 4px;
    span {
      padding: 3px 4px;
    }
  }
`
